import GetStartedButton from './GetStartedButton';

export default function PlansView({
  plans,
  onSelect,
  isDarkMode,
  autoRedirectPlanId,
}) {
  const renderFeatureValue = (f) => {
    if (f.value && f.unit) return `${f.value} ${f.unit.replace('_', ' ')}`;
    if (f.value) return f.value;
    if (f.extra_value) return f.extra_value;
    return '';
  };
  const PLAN_ORDER = ['Free', 'Basic', 'Professional'];
  const orderedPlans = [...plans].sort(
    (a, b) => PLAN_ORDER.indexOf(a.name) - PLAN_ORDER.indexOf(b.name)
  );

  return (
    <div>
      <div className="text-center px-6 pt-6">
        <h2
          className={`text-2xl font-semibold ${
            isDarkMode ? 'text-gray-100' : 'text-gray-900'
          }`}
        >
          Choose Your Plan
        </h2>
        <p
          className={`text-sm mt-1 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-500'
          }`}
        >
          Select the plan that best fits your needs.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
        {orderedPlans?.map((plan) => {
          const coreFeatures =
            plan?.features?.filter((f) => f?.category === 'Core') ?? [];

          const additionalFeatures =
            plan?.features?.filter((f) => f?.category === 'Additional') ?? [];

          // 🎨 Conditional styles for dark/light modes
          const cardBase = isDarkMode
            ? 'bg-gray-900 border-gray-700 text-gray-100 hover:bg-gray-800'
            : 'bg-white border-gray-200 text-gray-900 hover:shadow-lg hover:bg-gray-50';

          const freeCard = isDarkMode
            ? 'bg-gray-800 border-brand text-gray-300 cursor-default'
            : 'bg-[#C1C3D9] border-brand text-gray-700 cursor-default';

          return (
            <div
              key={plan.id}
              className={`rounded-lg border flex flex-col p-5 text-center transition-all duration-200 ${
                plan.name === 'Free' ? freeCard : cardBase
              }`}
            >
              <h3 className="text-lg font-semibold">{plan.name}</h3>
              <p className="text-2xl font-bold mt-1">
                {plan.price === 0 ? '$0/mo' : `$${plan.price}/mo`}
              </p>
              <p
                className={`text-xs mt-1 mb-3 capitalize ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-500'
                }`}
              >
                {plan.billing_cycle} billing
              </p>

              <ul
                className={`text-xs flex-1 space-y-1 text-left ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}
              >
                <li
                  className={`font-semibold mb-1 ${
                    isDarkMode ? 'text-gray-200' : 'text-gray-600'
                  }`}
                >
                  Core Features
                </li>
                {coreFeatures.map((f, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-brand mr-2">✓</span>
                    {renderFeatureValue(f)} {f.feature}
                  </li>
                ))}
                <li
                  className={`font-semibold mt-2 mb-1 ${
                    isDarkMode ? 'text-gray-200' : 'text-gray-600'
                  }`}
                >
                  Additional
                </li>
                {additionalFeatures.map((f, i) => (
                  <li key={i} className="flex items-start">
                    {renderFeatureValue(f)} {f.feature}
                  </li>
                ))}
              </ul>

              {plan.name === 'Free' ? (
                <button
                  disabled
                  className={`w-full py-2 mt-5 rounded font-semibold text-sm ${
                    isDarkMode
                      ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
                      : 'bg-gray-200 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  Your Current Plan
                </button>
              ) : (
                <div className="mt-5 flex justify-center">
                  <GetStartedButton
                    packageId={plan.id}
                    forceLoading={autoRedirectPlanId === plan.id}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
